export default __webpack_public_path__ + "static/media/kaikas-logo.5c3df97c.svg";